import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { CContainer, CFade } from "@coreui/react";

// routes config
import PrivateRoute from "../../routing/PrivateRoute";

//Redux
import { useSelector } from "react-redux";

//Admin, bracnh riutes
const {
  adminRoutes,
  branchRoutes,
  deliveryRoutes,
  offlineRoutes,
  orderRoutes,
} = require("../../routing/Routes");

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const TheContent = () => {
  const getRoute = () => {
    if (role === "admin") {
      return adminRoutes;
    } else if (role === "branch") {
      return branchRoutes;
    } else if (role === "deliveryexecutive") {
      return deliveryRoutes;
    } else if (role === "offlineexecutive") {
      return offlineRoutes;
    } else if (role === "orderexecutive") {
      return orderRoutes;
    }
  };

  const role = useSelector((state) => state.auth.user.role);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <main className="c-main">
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Switch>
            {isAuthenticated ? (
              getRoute().map((route, idx) => {
                return (
                  route.component && (
                    <PrivateRoute
                      key={idx}
                      route={route}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) => (
                        <CFade>
                          <route.component {...props} />
                        </CFade>
                      )}
                    />
                  )
                );
              })
            ) : (
              <Redirect to="/" />
            )}
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};

export default React.memo(TheContent);
